import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button, ButtonGroup, Menu, MenuItem } from '@mui/material';
import React from 'react';

interface WorkflowExportSplitButtonProps {
  label: string;
  onDownload: () => void;
  onDownloadSpecificVersions: () => void;
}

// The label downloads the default results. The attached menu opens the detailed version chooser.
export const WorkflowExportSplitButton: React.FC<WorkflowExportSplitButtonProps> = ({
  label,
  onDownload,
  onDownloadSpecificVersions,
}) => {
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
  const menuId = React.useId();
  const closeMenu = () => setAnchor(null);

  return (
    <>
      <ButtonGroup variant="outlined" color="secondary" aria-label={label}>
        <Button
          onClick={onDownload}
          startIcon={<FileDownloadOutlinedIcon />}
          sx={{ minWidth: 'max-content', whiteSpace: 'nowrap' }}
        >
          {label}
        </Button>
        <Button
          aria-haspopup="menu"
          aria-expanded={Boolean(anchor)}
          aria-controls={anchor ? menuId : undefined}
          aria-label={`${label} options`}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ px: 1, minWidth: 'auto' }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Menu
        id={menuId}
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            closeMenu();
            onDownloadSpecificVersions();
          }}
        >
          Download specific version/s
        </MenuItem>
      </Menu>
    </>
  );
};
